module.exports = __webpack_public_path__ + "img/checker.e2a142a2.svg";